import { CEPeriodAttributesBase } from './ce-period-attributes-base'


export class CEPeriodAttributes extends CEPeriodAttributesBase {

}